export enum FacilityTypeEnum {
    PhysicalHealth = 1,
    PhysicalHealthDescription = 'Physical Health',
    BehavioralHealthLevel1 = 2,
    BehavioralHealthLevel1Description = 'Behavioral Health Level 1',
    BehavioralHealthLevel2 = 3,
    BehavioralHealthLevel2Description = 'Behavioral Health Level 2',
}
